import { render, staticRenderFns } from "./range-price2.vue?vue&type=template&id=2e9e275c&"
import script from "./range-price2.vue?vue&type=script&lang=js&"
export * from "./range-price2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RangeSlider2: require('/var/www/components/range/range-slider2.vue').default})
